import { Adapter } from './adapters/types';
import { AnalyticsEvent } from './events';

interface TrackerState {
  enabled: boolean;
  adapters: Adapter[];
}

let state: TrackerState = { enabled: false, adapters: [] };

export const initTracker = (opts: { enabled: boolean; adapters: Adapter[] }) => {
  state = { enabled: opts.enabled, adapters: opts.adapters };
};

export const track = (event: AnalyticsEvent): void => {
  if (!state.enabled) return;
  for (const adapter of state.adapters) {
    try {
      adapter.send(event);
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('[analytics] adapter failed', adapter.name, e);
    }
  }
};

export const _resetForTests = () => {
  state = { enabled: false, adapters: [] };
};
